import { useState } from "react";
import { submitQuote } from "@/lib/api";

export default function QuoteForm() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");

  const send = async () => {
    if (!name.trim() || !message.trim()) {
      setStatus("error");
      return;
    }

    setStatus("sending");
    // Save the quote to the D1-backed API (best effort — never block WhatsApp).
    try {
      await submitQuote({ name, phone, email, message });
      setStatus("sent");
    } catch {
      setStatus("error");
    }

    const text = `
*NEW QUOTE REQUEST*

Name: ${name}
Phone: ${phone}
Email: ${email}

Requirements:
${message}
`;

    window.open(
      `https://wa.me/27660198386?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
    <section className="bg-[#0b111c] py-24" id="quote">
      <div className="max-w-4xl mx-auto px-6">

        <h2 className="text-5xl font-black text-center text-white">
          REQUEST A QUOTE
        </h2>

        <p className="text-center text-gray-400 mt-4 mb-12">
          Tell us about your project and we'll get back to you quickly.
        </p>

        <div className="space-y-6">

          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e)=>setName(e.target.value)}
            className="w-full rounded-xl bg-[#11192b] p-4 text-white border border-sky-500/20"
          />

          <input
            type="text"
            placeholder="Phone Number"
            value={phone}
            onChange={(e)=>setPhone(e.target.value)}
            className="w-full rounded-xl bg-[#11192b] p-4 text-white border border-sky-500/20"
          />

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            className="w-full rounded-xl bg-[#11192b] p-4 text-white border border-sky-500/20"
          />

          <textarea
            rows={6}
            placeholder="Tell us what you'd like printed..."
            value={message}
            onChange={(e)=>setMessage(e.target.value)}
            className="w-full rounded-xl bg-[#11192b] p-4 text-white border border-sky-500/20"
          />

          <button
            onClick={send}
            disabled={status === "sending"}
            className="w-full rounded-xl bg-sky-500 py-4 text-xl font-bold text-white hover:bg-sky-400 transition disabled:opacity-60"
          >
            {status === "sending" ? "Sending..." : "Send via WhatsApp"}
          </button>

          {status === "sent" && (
            <p className="text-center text-emerald-400">
              Quote saved — opening WhatsApp to finish sending.
            </p>
          )}
          {status === "error" && (
            <p className="text-center text-amber-400">
              Please enter at least your name and requirements.
            </p>
          )}

        </div>

      </div>
    </section>
  );
}
